export const EXPIRED_SESSION_KEY = 'expired-session';
